import React from 'react';
import { useQuery } from '@apollo/client';
import { DiscountCardContainer, Loading } from '../Common';
import { FormCell } from '../FormStructure';
import { ERROR_MESSAGE } from '../Messages/Messages';
import { RewardsLinkPropTypes, RewardsLinkDefaultProps } from './props';
import { REWARDS_TEXT_QUERY } from './operations';

export default function RewardsLink({ isMobileView }) {
  const { loading, error, data } = useQuery(REWARDS_TEXT_QUERY, {
    ssr: false,
    context: { batch: true },
    refetchPolicy: 'network-only',
  });

  if (loading) return <Loading isLoading={loading} />;
  if (error) return ERROR_MESSAGE;

  const { textFor = {}, coupons = [] } = data;
  const { redeemInBagText, exclusionsApplyLabelText } = textFor;

  const renderDiscountDetails = (text, href) => (
    <a
      target="_self"
      rel="noreferrer"
      href={href}
      style={{ display: 'block' }}
      className="open-modal-link"
    >
      { text }
    </a>
  );

  const renderDiscountCardContainer = ({
    title,
    description,
    badge,
    expiration,
    exclusionLink,
    id,
  }) => (
    <DiscountCardContainer
      key={`discountcard_${id}`}
      discountTitle={title.value}
      discountSecondaryTitle={description?.key ? description?.value : ''}
      graphicBadge={badge}
      discountDescription={expiration.value}
      id={id}
      discountMessage={redeemInBagText.value}
      discountDetails={
        renderDiscountDetails(exclusionsApplyLabelText?.value, exclusionLink)
      }
      orientation={isMobileView ? 'stacked' : null}
    />
  );

  if (coupons.length === 0) return null;
  return (
    <FormCell>
      <div className="rewards-coupons" data-testid="rewards-section">
        { coupons.slice(0, 5).map(renderDiscountCardContainer) }
      </div>
    </FormCell>
  );
}

RewardsLink.propTypes = RewardsLinkPropTypes;
RewardsLink.defaultProps = RewardsLinkDefaultProps;
